// Parça/işçilik adlarına otomatik teknik açıklama eşleştirici.
// Müşteri ekranında ve PDF'te "değer algısı" yaratmak için kullanılır.
// Eşleşme: küçük harfe çevir + Türkçe karakter normalize + substring match.

const NORMALIZE = (s) =>
  (s || "")
    .toLocaleLowerCase("tr")
    .replace(/ı/g, "i")
    .replace(/[İI]/g, "i")
    .replace(/ş/g, "s")
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .trim();

// keyword (normalized) → açıklama
const DICTIONARY = [
  { kw: ["ana kart", "kontrol kartı", "anakart", "elektronik kart", "pcb"], desc: "Elektronik kontrol ünitesi. Programlama, sıfırlama ve cihaz fonksiyon testleri dahildir." },
  { kw: ["eşanjör", "esanjor", "isi degistirici", "ısı değiştirici", "heat exchanger"], desc: "Cihazın ısı transfer ünitesi. Demontaj, tesisat temizliği ve montaj işlemleri dahildir." },
  { kw: ["sirkülasyon pompası", "sirkulasyon pompasi", "pompa", "sirkulator"], desc: "Suyu sistem içinde döndüren motorlu pompa. Mil sızdırmazlığı, hava alma ve test dahildir." },
  { kw: ["genleşme tankı", "genlesme tanki", "tank", "membran tanki"], desc: "Sistemdeki basıncı dengeleyen tank. Gaz basınç kontrolü ve montaj dahildir." },
  { kw: ["fan motoru", "fan", "vantilator", "vantilatör"], desc: "Hava sirkülasyon motoru. Rulman kontrolü, dengeleme ve test dahildir." },
  { kw: ["gaz valfi", "gaz vanası", "gas valve", "gaz valvi"], desc: "Yakıt akışını kontrol eden valf. Sızdırmazlık testi ve gaz/hava karışım ayarı dahildir." },
  { kw: ["kapasitör", "kapasitor", "kondansator", "kondansatör", "capacitor"], desc: "Motor başlatma kondansatörü. Kapasite ölçümü ve elektriksel test dahildir." },
  { kw: ["filtre", "filter"], desc: "Yakıt/hava/su filtresi. Temizlik, değişim ve sistem kontrolü dahildir." },
  { kw: ["termostat", "termistor", "termistör", "ntc", "sicaklik sensoru", "sıcaklık sensörü"], desc: "Sıcaklık kontrol elemanı. Kalibrasyon ve fonksiyon testi dahildir." },
  { kw: ["manometre", "basınç sensörü", "basinc sensoru", "pressure sensor", "presostat"], desc: "Sistem basınç ölçüm cihazı. Kalibrasyon ve sızdırmazlık testi dahildir." },
  { kw: ["conta", "o-ring", "oring", "salmastra", "gasket"], desc: "Sızdırmazlık elemanları. Tüm temas yüzeylerinin temizliği ile birlikte montaj dahildir." },
  { kw: ["rakor", "fitting", "te", "dirsek"], desc: "Bağlantı elemanı. Sızdırmazlık testi ve montaj dahildir." },
  { kw: ["vana", "valf", "valve"], desc: "Akış kontrol elemanı. Sızdırmazlık testi ve montaj dahildir." },
  { kw: ["rezistans", "ısıtıcı", "isitici", "heater", "heating element"], desc: "Elektrikli ısıtma elemanı. Direnç ölçümü ve elektriksel test dahildir." },
  { kw: ["kompresör", "kompresor", "compressor"], desc: "Soğutucu akışkanı sıkıştıran ana ünite. Vakum + gaz şarjı + sistem testi dahildir." },
  { kw: ["freon", "soğutucu gaz", "sogutucu gaz", "r410", "r32", "refrigerant"], desc: "Soğutucu akışkan dolumu. Vakumlu kaçak testi ve basınç kontrolü dahildir." },
  { kw: ["kondenser serpantini", "kondenser"], desc: "Dış ünite ısı atma serpantini. Yüksek basınçlı temizlik ve test dahildir." },
  { kw: ["evaporatör", "evaporator", "buharlastirici", "buharlaştırıcı"], desc: "İç ünite ısı emici serpantin. Detaylı temizlik ve dezenfeksiyon dahildir." },
  { kw: ["uzaktan kumanda", "kumanda", "remote"], desc: "Cihaz kumanda ünitesi. Pil, eşleştirme ve fonksiyon testi dahildir." },
  { kw: ["kablo", "cable", "harness", "tesisat"], desc: "Sinyal/güç bağlantı kablosu. Topraklama ve süreklilik testi dahildir." },
  { kw: ["doldurma valfi", "su girişi", "su giris", "musluk"], desc: "Su besleme elemanı. Sızdırmazlık ve basınç testi dahildir." },
  { kw: ["baca", "baca seti", "flue", "fan baca"], desc: "Atık gaz tahliye elemanı. Çekiş ve sızdırmazlık testi dahildir." },
  { kw: ["ateşleyici", "atesleyici", "ateşleme", "atesleme", "ignitor", "elektrot"], desc: "Yakıt ateşleme ünitesi. Kıvılcım kontrolü ve yanma analizi dahildir." },
  { kw: ["brulör", "brulor", "burner", "yakıcı", "yakici"], desc: "Yanma ünitesi. Hava/gaz karışım ayarı ve yanma testi dahildir." },
  { kw: ["üç yollu vana", "uc yollu vana", "3 yollu", "3-yollu", "diverter"], desc: "Suyu kullanım/ısıtma devresine yönlendiren motorlu vana. Aktüatör testi dahildir." },
  { kw: ["servo motor", "servo"], desc: "Hassas konumlandırma motoru. Kalibrasyon ve hareket testi dahildir." },
  { kw: ["safe", "limit termik", "limit termostat", "emniyet"], desc: "Aşırı ısınma koruma elemanı. Devreye girme noktası kontrol edilir." },
  { kw: ["bakim", "bakım", "yıllık bakım", "yillik bakim", "service kit"], desc: "Periyodik bakım paketi. Tüm bakım kalemleri, temizlik ve performans testi dahildir." },
];

const PART_FALLBACK = "Orijinal yedek parça temini, montaj işçiliği ve sistem testi dahildir.";

export const LABOR_DESCRIPTION =
  "Sahada yapılan tüm teşhis, sökme-takma, kalibrasyon ve fonksiyon testi işçilik kalemine dahildir.";

export function describePart(name) {
  if (!name) return PART_FALLBACK;
  const n = NORMALIZE(name);
  for (const entry of DICTIONARY) {
    for (const kw of entry.kw) {
      if (n.includes(NORMALIZE(kw))) return entry.desc;
    }
  }
  return PART_FALLBACK;
}

// Müşteri ekranında listelenen "DAHİL" hizmetler (ücretsiz görünür, değer algısı).
export const INCLUDED_SERVICES = [
  "Cihaz arıza teşhisi ve detaylı sistem analizi",
  "Sızdırmazlık ve basınç kontrolü",
  "Çalışma performans kalibrasyonu",
  "Yapılan tüm işlemlerin son fonksiyon testi",
];

export const WARRANTY = {
  parts: "12 Ay Parça Garantisi",
  labor: "12 Ay İşçilik Garantisi",
};
